export const pluralize = (
  singular: string,
  count?: number,
  customPlural?: string,
) => {
  if (count === 1) return singular;
  if (customPlural) return customPlural;
  return `${singular}s`;
};

export const pluralizedCount = (
  singular: string,
  count?: number,
  customPlural?: string,
) => {
  const countStr = count === undefined ? '' : `${count} `;
  return `${countStr}${pluralize(singular, count, customPlural)}`;
};
